import {  useMutation } from '@tanstack/react-query';
import { useAllMarkReadApi } from '../../Hooks/useAllMarkReadApi';


// type Params = {
//   sortBy?: string;
//   sortOrder?: string;
//   page?: number;
//   limit?: number;
//   addedByFilter?: string;
//   statusFilter?: string;
//   search?: string;
// };

// export const useAllMarkRead = (queryParams: Params) => {
  
//   const { getAllMarkRead } = useAllMarkReadApi();
//   const {
//     data,
//     isLoading: isFetching,
//     refetch,
//     isRefetching,
//   } = useQuery({
//     queryKey: ['getMarkRead', queryParams],
//     queryFn: () => {
//       return getAllMarkRead(queryParams);
//     },
//   });

//   const isLoading = isFetching || isRefetching;

//   return {
//     data,
//     isLoading,
//     refetch,
//   };
// };


export const useAllMarkRead = () => {
  const { getAllMarkRead } = useAllMarkReadApi();

  return useMutation({
    mutationFn: (body: { userId: string; userType: string; isRead: boolean }) => {
      return getAllMarkRead(body);
    },
  });
};